<span class="article-type__badge">
  <svg
    class="article-type__dot"
    [class]="color"
    viewBox="0 0 6 6"
    aria-hidden="true"
  >
    <circle cx="3" cy="3" r="3" />
  </svg>
  {{ label }}
  @if (removable) {
  <button
    type="button"
    class="article-type__remove"
    aria-label="Quitar"
    (click)="handleRemove($event)"
  >
    <svg viewBox="0 0 14 14" aria-hidden="true">
      <path
        d="M4 4l6 6m0-6l-6 6"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
      />
    </svg>
  </button>
  }
</span>
